import { clearAppActiveContext } from 'src/api/appActiveContext';

export const completeMagicLinkAuthentication = (redirect: () => void) => {
    clearAppActiveContext();
    redirect();
};
